module.exports = __webpack_public_path__ + "static/media/44506956_2199902400084939_593918901008465920_o-thumb.f07b8c86.jpg";